// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/ContactPage.css */
.contact-page {
    background: linear-gradient(to bottom right, #f0f9ff, #e0f2fe);
    min-height: 100vh;
    padding: 6rem 1rem;
    font-family: 'Poppins', sans-serif;
  }
  
  .contact-container {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
  }
  
  .contact-container h1 {
    font-size: 2.5rem;
    color: #1e293b;
    margin-bottom: 1rem;
  }
  
  .contact-container > p {
    font-size: 1.2rem;
    color: #475569;
    max-width: 600px;
    margin: 0 auto 3rem;
  }
  
  .contact-methods {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2.5rem;
    margin-top: 3rem;
  }
  
  .contact-method {
    background: white;
    border-radius: 16px;
    padding: 2.5rem;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease;
  }
  
  .contact-method:hover {
    transform: translateY(-5px);
  }
  
  .contact-icon {
    width: 70px;
    height: 70px;
    background: #dbeafe;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.5rem;
  }
  
  .contact-icon svg {
    width: 32px;
    height: 32px;
    color: #2563eb;
  }
  
  .contact-method h2 {
    font-size: 1.5rem;
    color: #1e293b;
    margin-bottom: 1rem;
  }
  
  .contact-method p {
    color: #475569;
    line-height: 1.6;
    margin-bottom: 0.5rem;
  }
  
  .contact-method a {
    color: #2563eb;
    text-decoration: none;
    font-weight: 500;
  }
  
  .contact-method a:hover {
    text-decoration: underline;
  }
  
  @media (max-width: 768px) {
    .contact-page {
      padding: 4rem 1rem;
    }
    
    .contact-methods {
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }
    
    .contact-method {
      padding: 1.5rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/ContactPage.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,8DAA8D;IAC9D,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gDAAgD;IAChD,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,0BAA0B;MAC1B,WAAW;IACb;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":["/* src/pages/ContactPage.css */\n.contact-page {\n    background: linear-gradient(to bottom right, #f0f9ff, #e0f2fe);\n    min-height: 100vh;\n    padding: 6rem 1rem;\n    font-family: 'Poppins', sans-serif;\n  }\n  \n  .contact-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    text-align: center;\n  }\n  \n  .contact-container h1 {\n    font-size: 2.5rem;\n    color: #1e293b;\n    margin-bottom: 1rem;\n  }\n  \n  .contact-container > p {\n    font-size: 1.2rem;\n    color: #475569;\n    max-width: 600px;\n    margin: 0 auto 3rem;\n  }\n  \n  .contact-methods {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 2.5rem;\n    margin-top: 3rem;\n  }\n  \n  .contact-method {\n    background: white;\n    border-radius: 16px;\n    padding: 2.5rem;\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);\n    transition: transform 0.3s ease;\n  }\n  \n  .contact-method:hover {\n    transform: translateY(-5px);\n  }\n  \n  .contact-icon {\n    width: 70px;\n    height: 70px;\n    background: #dbeafe;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 1.5rem;\n  }\n  \n  .contact-icon svg {\n    width: 32px;\n    height: 32px;\n    color: #2563eb;\n  }\n  \n  .contact-method h2 {\n    font-size: 1.5rem;\n    color: #1e293b;\n    margin-bottom: 1rem;\n  }\n  \n  .contact-method p {\n    color: #475569;\n    line-height: 1.6;\n    margin-bottom: 0.5rem;\n  }\n  \n  .contact-method a {\n    color: #2563eb;\n    text-decoration: none;\n    font-weight: 500;\n  }\n  \n  .contact-method a:hover {\n    text-decoration: underline;\n  }\n  \n  @media (max-width: 768px) {\n    .contact-page {\n      padding: 4rem 1rem;\n    }\n    \n    .contact-methods {\n      grid-template-columns: 1fr;\n      gap: 1.5rem;\n    }\n    \n    .contact-method {\n      padding: 1.5rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
